/* eslint-disable no-undef */
const ELCA_DISPLAY_PRODUCT_DOCUMENTATION_LOG = '[]';
window.ElcaDisplayProductDocumentationWidget = window.ElcaDisplayProductDocumentationWidget || {};

ElcaDisplayProductDocumentationWidget.geoLocalizationUserDoc = function() {
    if ($('#widgetBlock').val() == 'False') {

        $.getJSON('https://api.ipify.org?format=json',
            function (data) {
                $.getJSON('/Sitefinity/Public/Services/GeoLocation/GeoLocation.svc/' + data.ip,
                    function () {
                    })
                    .done(function (userIpCountry) {
                        var jsonParse = JSON.parse(userIpCountry);

                        if (jsonParse.ErrorMessage) {
                            console.error(ELCA_DISPLAY_PRODUCT_DOCUMENTATION_LOG, 'Unable to complete geoLocalization');// eslint-disable-line no-console
                        }
 else {
                            ElcaDisplayProductDocumentationWidget.saveAccessAndCheckAllowedCountry(
                                jsonParse.Ip,
                                jsonParse.GeoLocationDateTime,
                                jsonParse.IsoCode,
                                jsonParse.Country,
                                jsonParse.City,
                                jsonParse.Region
                            );
                            return userIpCountry;
                        }

                    })
                    .fail(function () {
                        console.error(ELCA_DISPLAY_PRODUCT_DOCUMENTATION_LOG, 'GeoLocalization call failed');// eslint-disable-line no-console
                    })
                    .always(function () {
                        console.log(ELCA_DISPLAY_PRODUCT_DOCUMENTATION_LOG, 'GeoLocalization call completed');// eslint-disable-line no-console
                        $('#mi-corpo-elcauserdoc-loading-img').css('display', 'none');

                    });
                });
    }
};

ElcaDisplayProductDocumentationWidget.saveAccessAndCheckAllowedCountry = function(ip, dateTime, isocode, country, city, region) {
    var queryString = '?' +
        $('.mi-corpo-UserDoc-hidden-data-form').serialize() +
        '&ip=' +
        ip +
        '&dateTime=' +
        dateTime +
        '&isocode=' +
        isocode +
        '&country=' +
        country +
        '&city=' +
        city +
        '&region=' +
        region +
        '&lang=' +
        document.documentElement.lang;
    var requestManager = new AsyncRequestManager();
    requestManager.renderSyncRequest('/UserDoc/saveAccessAndCheckAllowedCountry', queryString, '#mi-corpo-userdoc');
};

ElcaDisplayProductDocumentationWidget.setPageElementsEvents = function() {
    $('#mi-corpo-display-product-documentation-product-selector').on('change',
        function () {
            $('#mi-corpo-display-product-documentation-loading-img').css('display', 'block');
            var requestManager = new AsyncRequestManager();
            var productName =
                encodeURIComponent($('#mi-corpo-display-product-documentation-product-selector option:selected')
                    .text());
            var language = $('html').attr('lang');

            requestManager.renderAsyncRequest('/userdocumentation-display/search-product', '?productName=' + productName, '#mi-corpo-userdoc', false, language);
        });

    $('#mi-corpo-display-product-documentation-language-selector').on('change',
        function () {

            $('#mi-corpo-display-product-documentation-product-documents-links').children('div').each(function () {

                if (($.trim($(this).find('.lang').text()) ==
                    $('#mi-corpo-display-product-documentation-language-selector option:selected').val() ||
                    $('#mi-corpo-display-product-documentation-language-selector option:selected').val() == '') &&
                    ($.trim($(this).find('.categ').attr('name')) ==
                        $('#mi-corpo-display-product-documentation-document-type-selector option:selected').val() ||
                        $('#mi-corpo-display-product-documentation-document-type-selector option:selected').val() == '')) {
                    $(this).show();
                }
 else {
                    $(this).hide();
                }
            });
        });

    $('#mi-corpo-display-product-documentation-document-type-selector').on('change',
        function () {

            $('#mi-corpo-display-product-documentation-product-documents-links').children('div').each(function () {
                if (($.trim($(this).find('.lang').text()) ==
                    $('#mi-corpo-display-product-documentation-language-selector option:selected').val() ||
                    $('#mi-corpo-display-product-documentation-language-selector option:selected').val() == '') &&
                    ($.trim($(this).find('.categ').attr('name')) ==
                        $('#mi-corpo-display-product-documentation-document-type-selector option:selected').val() ||
                        $('#mi-corpo-display-product-documentation-document-type-selector option:selected').val() == '')) {
                    $(this).show();
                }
 else {
                    $(this).hide();
                }
            });
        });
};
